import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import SportsMenu from 'modules/sports-menu/index.js';
import SettingsMenu from 'modules/settings-menu/index.js';
import AzOverview from 'modules/az-menu/states/root/index.js';

const { FlexPane, Text, Image, Button, ScrollPane, ComponentsRouter } =
    MojitoPresentation.Components;

export default class AZMenu extends MojitoCore.Presentation.UIViewImplementation {
    constructor(...args) {
        super(...args);
        this.renderRootState = this.renderRootState.bind(this);
        this.renderAllSportsState = this.renderAllSportsState.bind(this);
        this.renderAllSettingsState = this.renderAllSettingsState.bind(this);
        this.backClickWrapper = this.clickWrapper.bind(this);
        this.onScrollPaneScroll = this.onScrollPaneScroll.bind(this);

        this.rootStateName = 'root';
        this.defaultStates = [
            {
                name: 'root',
                renderer: this.renderRootState,
            },
            {
                name: 'all-sports',
                renderer: this.renderAllSportsState,
            },
            {
                name: 'settings',
                renderer: this.renderAllSettingsState,
            },
        ];

        this.states = this.generateSequentialStates([
            ...(this.config.states || []),
            ...this.defaultStates,
        ]);

        this.state = {
            isScrolled: false,
        };
    }

    onScrollPaneScroll(containerInfo) {
        const isScrolled = containerInfo.scrollPosition > 0;
        if (this.state.isScrolled !== isScrolled) {
            this.setState({
                isScrolled,
            });
        }
    }

    generateSequentialStates(states) {
        return states.map(({ name, renderer }) => {
            let sequentialStateRenderer;
            if (name !== this.rootStateName) {
                sequentialStateRenderer = (to, back) => {
                    const wrappedBack = () => this.clickWrapper(back, name);

                    return this.renderSequentialState(
                        {
                            back: wrappedBack,
                            label: this.resolveString('$AZ_MENU.BACK_BUTTON'),
                        },
                        renderer(to, back)
                    );
                };
            }
            return { name, renderer: sequentialStateRenderer || renderer };
        });
    }

    clickWrapper(backFunction, name) {
        if (name === 'all-sports') {
            this.emitAnalytics('sportsMenuExpandedStateChanged', false);
        }
        this.setState({
            isScrolled: false,
        });
        backFunction();
    }

    renderRootState(to) {
        return (
            <AzOverview
                to={to}
                onClose={this.props.onClose}
                config={this.config.azOverview}
                renderSearchComponent={this.props.renderSearchComponent}
                renderSearchOverlay={this.props.renderSearchOverlay}
                hideSettings={this.config.settingsMenu.hide}
            />
        );
    }

    renderAllSportsState() {
        return <SportsMenu config={this.config.sportsMenu} cbSportClicked={this.props.onClose} />;
    }

    renderAllSettingsState() {
        return <SettingsMenu config={this.config.settingsMenu} />;
    }

    renderSequentialState(backButton, content) {
        return (
            <FlexPane config={this.config.sequentialStateContainer}>
                <Button
                    class="ta-backButton"
                    onClick={backButton.back}
                    config={
                        this.state.isScrolled
                            ? this.config.sequentialStateBackButtonScrolled
                            : this.config.sequentialStateBackButton
                    }
                >
                    <Image config={this.config.sequentialStateBackButtonIcon} />
                    <Text config={this.config.sequentialStateBackButtonLabel}>
                        {backButton.label}
                    </Text>
                </Button>
                <ScrollPane
                    onScroll={this.onScrollPaneScroll}
                    config={this.config.sequentialScrollContainer}
                >
                    {content}
                </ScrollPane>
            </FlexPane>
        );
    }

    render() {
        return <ComponentsRouter startFrom={this.rootStateName} states={this.states} />;
    }
}
